import { render, staticRenderFns } from "./OhGroupHours.vue?vue&type=template&id=f0c06e24&scoped=true&"
import script from "./OhGroupHours.vue?vue&type=script&lang=js&"
export * from "./OhGroupHours.vue?vue&type=script&lang=js&"
import style0 from "./OhGroupHours.vue?vue&type=style&index=0&id=f0c06e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c06e24",
  null
  
)

export default component.exports